import { create } from 'zustand';
import { ApiUtils, FileApi, FileEntity, RequestStrategyEnum } from '@shared/api';

interface IApplicationFilesStore {
  loading: boolean;
  error: string | null;
  applicationFiles: FileEntity[];
  getApplicationFiles: (applicationId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationFilesStore = create<IApplicationFilesStore>((set) => ({
  loading: false,
  error: null,
  applicationFiles: [],

  getApplicationFiles: ApiUtils.wrapperApi(async (applicationId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await FileApi.getApplicationFiles(applicationId, signal);
      set({ applicationFiles: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ applicationFiles: [], loading: false, error: null }),
}));
